export function getDismissedNotifications() {
	const recordedDismissedNotifications = window.localStorage.getItem("plaudit-dismissed-notifications");
	if (!recordedDismissedNotifications) {
		return [];
	}
	const dismissedNotifications = recordedDismissedNotifications.split(';')
			.map(t => {
				const colonIndex = t.indexOf(':');
				return [parseInt(t.substring(0, colonIndex)), parseInt(t.substring(colonIndex + 1))] as const;
			})
			// This filters out dismissal records that either no longer correspond to an active notification or that have expired
			.filter(([id, expiration]) => document.getElementById(`notification-${id}`) && (expiration === 0 || expiration > Date.now()));

	// We write the filtered list back into local storage to trim unused notifications from the list
	window.localStorage.setItem("plaudit-dismissed-notifications", dismissedNotifications.map(v => v.join(':')).join(';'));
	return dismissedNotifications.map(([id]) => id);
}
